import { render, staticRenderFns } from "./AcceptLogs.vue?vue&type=template&id=8a419d54&"
import script from "./AcceptLogs.vue?vue&type=script&lang=js&"
export * from "./AcceptLogs.vue?vue&type=script&lang=js&"
import style0 from "./AcceptLogs.vue?vue&type=style&index=0&id=8a419d54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports